var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-combobox',{attrs:{"items":_vm.items,"label":_vm.label,"disabled":_vm.disabled,"outlined":"","dense":""},on:{"change":_vm.changeSelect}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }